(function () {

  'use strict';

  angular.module(moduleConfig.applicationModuleName)

    .controller('appCtrl', ['$scope', '$http', '$location', '$window', '$rootScope', '$document', 'util', '$state', 'cfaService', '$translate', 'cartManager',
      function ($scope, $http, $location, $window, $rootScope, $document, util, $state, cfaService, $translate, cartManager) {

        // close menu on load
        $rootScope.ruiMethods.toggleMobileMenu(false);

        // check if there's anything for the wireless cart
        $scope.wirelessCartQuantity = cartManager.wireless.get.cartQuantity();

        // if it's a cfa landing, check for language and province params
        //if ($state.current.name === 'cfaLanding') {
        //  $rootScope.userPref = cfaService.getCFAData();
        //  console.log('userPref set to', $rootScope.userPref);
        //}

        $translate('global.pageTitle.' + $rootScope.currentState.title, { brandName: '| Fido.ca' })
          .then(function (result) {
            $rootScope.websiteTitle = result;
          });

        $http.get('assets/build-date.json')
          .then(function (result) {
            $rootScope.buildDate = result.data.date;
            $window.buildDate = result.data.date;
            console.log('buildDate', $rootScope.buildDate);
          });



      }]);

})();
